<template>
  <div class="comment-card py-4 px-5">
    <div class="comment-head flex items-center gap-2.5 select-none">
      <nd-img
        v-if="shouldShowDefaultAvatar"
        :src="commenterAvatarImagePath"
        alt="fail to fetch image"
        width="28"
        height="28"
        class="aspect-square rounded-full object-cover"
      />
      <div v-else class="avatar flex items-center justify-center text-white rounded-full w-7 h-7" :class="avatarBackgroundColorClass">
        <div class="text-base">{{ commenterFirstLetter }}</div>
      </div>
      <div class="right-group flex flex-col gap-1">
        <span class="name text-sm">{{ props.comment.rated_by }}</span>
        <n-rate :default-value="props.comment.rating" :count="5" :show-text="false" readonly size="small" />
      </div>
    </div>
    <div class="content mt-4">{{ props.comment.rating_description }}</div>
    <div class="tags mt-4 flex flex-wrap gap-2">
      <div v-for="tag in props.comment.tags" :key="tag.tag_id" class="tag bg-gray-20 py-0.5 px-2 rounded">
        <span class="text-gray-80 text-xs">{{ tag.tag_name }}</span>
      </div>
    </div>
    <div class="comment-footer flex justify-between items-center mt-4">
      <span class="date text-sm">{{ commentDate }}</span>
      <!-- <nd-button size="small" type="text" class="text-sm" icon="heart">有用</nd-button> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { parseISO } from 'date-fns'
import { NRate } from 'naive-ui'
import type { FreviewReviewData } from '@/types/api'

const { format } = await useI18nDateFns()

const props = defineProps<{
  comment: FreviewReviewData
}>()

const { comment } = toRefs(props)
const { commenterAvatarImagePath, avatarBackgroundColorClass } = useMembershipLevel(comment)

const commenterName = computed(() => props.comment.rated_by)
const { shouldShowDefaultAvatar, commenterFirstLetter } = useComment(commenterName)
const commentDate = computed(() => (props.comment.rate_time ? format(parseISO(props.comment.rate_time), 'yyyy/MM/dd') : ''))
</script>

<style lang="scss" scoped></style>
